import { i18nFilter } from "app/filters/i18nFilter";
import { PopupHoverContainerStyled } from "app/components/React/Table/cells/KeywordAnalysisPosition";

const popupConfig = {
    placement: "top",
};

export const KeywordAnalysisPositionNACall = ({ showTooltip = false }) => {
    if (showTooltip) {
        return (
            <PopupHoverContainerStyled
                config={popupConfig}
                content={() => <div>{i18nFilter()("keyword.analysis.position.na.call.tooltip")}</div>}
            >
                <div>N/A</div>
            </PopupHoverContainerStyled>
        );
    } else {
        return <div>N/A</div>;
    }
};
